import Vue from 'vue';
import { createHelpers } from 'vuex-map-fields';

import {
  TASKS_REQUEST_TASK,
  TASKS_ADD_TASK,
  TASKS_UPDATE_CURRENT_TASK,
  TASKS_LOADED,
  TASKS_CLEAR,
} from '../actions/tasks';

import {
  ROUTE_API_GET_TASK_SCHEDULER,
  ROUTE_API_SAVE_TASK_SCHEDULER,
  ROUTE_API_SAVE_CURRENT_TASK_SCHEDULER,
} from '@/constants/apiRoutes';

const { getTasksField, updateTasksField } = createHelpers({
  getterType: 'getTasksField',
  mutationType: 'updateTasksField',
});

/**
 * Möchte man an einer beliebigen Stelle der Anwendung den aktuellen Task ändern,
 * zum Beispiel wenn ein Antrag ausgefüllt wurde, dann muss an der Stelle folgender Code eingefügt werden,
 * mit der entsprechenden TaskID in der TASKS_UPDATE_CURRENT_TASK Action:
    this.$store
      .dispatch(TASKS_UPDATE_CURRENT_TASK, 'P1-70');
 */

const defaultCurrentTaskId = 'P1-10';

const state = {
  /**
   * P1-10: Einstieg ohne Pflegegrad
   * P2-40: Einstieg mit Pflegegrad
   */
  currentTaskId: defaultCurrentTaskId,
  completedTasks: [],
  tasksLoaded: false,
};

const getters = {
  getTasksField,
};

const mutations = {
  updateTasksField,

  [TASKS_LOADED]: (state) => {
    state.tasksLoaded = true;
  },

  [TASKS_REQUEST_TASK]: (state, { completedTasks, currentTaskId }) => {
    state.completedTasks = completedTasks;
    state.currentTaskId = currentTaskId;
  },

  [TASKS_CLEAR]: (state) => {
    state.completedTasks = [];
  },
};

const actions = {
  [TASKS_REQUEST_TASK]: ({ commit, rootState }) => {
    return new Promise((resolve, reject) => {
      Vue.axios
        .post(ROUTE_API_GET_TASK_SCHEDULER, { uuid: rootState.health.healthUuid })
        .then((response) => {
          const {
            status,
            data: { completedTasks, currentTaskId },
          } = response;

          if (status === 200) {
            commit(TASKS_REQUEST_TASK, {
              currentTaskId: currentTaskId || defaultCurrentTaskId,
              completedTasks,
            });
            commit(TASKS_LOADED);
            resolve();
          }
        })
        .catch(() => {
          commit(TASKS_LOADED);
          reject();
        });
    });
  },

  [TASKS_ADD_TASK]: ({ dispatch, rootState }, taskId) => {
    return new Promise((resolve, reject) => {
      const data = {
        task_id: taskId,
        uuid: rootState.health.healthUuid,
      };

      Vue.axios
        .post(ROUTE_API_SAVE_TASK_SCHEDULER, data)
        .then(() => {
          dispatch(TASKS_REQUEST_TASK).then(resolve).catch(reject);
        })
        .catch(reject);
    });
  },

  [TASKS_UPDATE_CURRENT_TASK]: ({ dispatch, rootState }, taskId) => {
    return new Promise((resolve, reject) => {
      const data = {
        currentTaskId: taskId,
        uuid: rootState.health.healthUuid,
      };

      Vue.axios
        .post(ROUTE_API_SAVE_CURRENT_TASK_SCHEDULER, data)
        .then(() => {
          dispatch(TASKS_REQUEST_TASK).then(resolve).catch(reject);
        })
        .catch(reject);
    });
  },

  [TASKS_CLEAR]: ({ commit }) => {
    commit(TASKS_CLEAR);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
